import { Enum } from "../../common/constants"
import api from "../api"

export const tenantDiagnosticsEndpoint = `/web/tenant-diagnostics`

export const CrewMemberUserLinkReasons = {
  UserNotFound: 'UserNotFound',
  UserDeleted: 'UserDeleted',
  UserInactive: 'UserInactive'
} as const

export type CrewMemberUserLinkReason = Enum<typeof CrewMemberUserLinkReasons>

export type CrewMemberUserLinkIssue = {
  crewMemberId: number
  crewMemberName: string
  crewMemberEmail: string | null
  isCrewMemberActive: boolean
  userEmail: string
  reason: CrewMemberUserLinkReason
}

export const LaborSkuSettings = {
  MaintenanceLaborSku: 'MaintenanceLaborSku',
  ProjectLaborSku: 'ProjectLaborSku',
  ServiceCallSku: 'ServiceCallSku'
} as const

export type LaborSkuSetting = Enum<typeof LaborSkuSettings>

export const LaborSkuReasons = {
  NotSet: 'NotSet',
  ItemNotFound: 'ItemNotFound',
  ItemRetired: 'ItemRetired',
  ItemNotLabor: 'ItemNotLabor',
  DuplicateSku: 'DuplicateSku'
} as const

export type LaborSkuReason = Enum<typeof LaborSkuReasons>

export type LaborSkuIssue = {
  setting: LaborSkuSetting
  sku: string
  matchedItemName: string | null
  reason: LaborSkuReason
}

export type TenantDiagnostics = {
  crewMemberUserLinkIssues: CrewMemberUserLinkIssue[]
  laborSkuIssues: LaborSkuIssue[]
}

export const getTenantDiagnostics = async (tenantId: number): Promise<TenantDiagnostics> => {
  return (await api.get<TenantDiagnostics>(`${tenantDiagnosticsEndpoint}/${tenantId}`)).data
}
